import styled from '@emotion/styled';
import { colors } from '@goshippo/components';
import * as logoCharcoal from '~/assets/logo/shippo_logo_charcoal.svg';
import { partnerSettings } from '~/constants/register';
import { ResponsiveBreakPoints } from '~/constants/responsive';

const LogoWrapper = styled('header')`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  background-color: ${colors.white};
  padding: 2.5rem 0;

  @media (max-width: ${ResponsiveBreakPoints.Tablet}px) {
    padding: 1.5rem 0;
    a {
      display: block;
    }
  }
`;

const ShippoLogo = styled('img')`
  height: auto;
  width: 7.75rem;
  margin-left: 2.5rem;
  @media (max-width: ${ResponsiveBreakPoints.Tablet}px) {
    width: 6.25rem;
    margin-left: 1.5rem;
  }
`;

const PartnerLogo = styled('img')`
  height: auto;
  width: 2.5rem;
`;

const LogoDivider = styled('hr')`
  height: 3rem;
  margin: 0 1rem;
  border: 0.5px solid ${colors.borders};
  @media (max-width: ${ResponsiveBreakPoints.Tablet}px) {
    height: 2rem;
    margin: 0 1rem;
  }
`;

interface PartnerHeaderProps {
  partner?: string;
}

const PartnerHeader = ({ partner }: PartnerHeaderProps) => {
  const partnerSetting = partner ? partnerSettings[partner] : undefined;

  return (
    <LogoWrapper>
      <ShippoLogo data-name="logo" src={logoCharcoal} alt="Shippo - Logo" />
      {partnerSetting && (
        <>
          <LogoDivider />
          <PartnerLogo src={partnerSetting.logo} alt={partnerSetting.alt} />
        </>
      )}
    </LogoWrapper>
  );
};

export default PartnerHeader;
